import { createBrowserRouter } from "react-router-dom";
import { AdminRoutes } from "./admin";
import { AuthRoutes } from "./auth";
import { FrontendRoutes } from "./frontend";

export const RouterRoutes = createBrowserRouter([AdminRoutes, AuthRoutes , FrontendRoutes])